import Button from '../../Button'
import { Container } from '../Container'

import { BUTTON_ICON_SIZES, BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function ContainedLight() {
  return (
    <>
      <Container label='Button, contained, light, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Contained
            isLight
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, contained, light, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Contained
            disabled
            isLight
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, contained, light, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Contained
            isLight
            isLoading
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, contained, light, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Contained
            isLight
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, contained, light, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Contained
            isLight
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, contained, light, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Contained
            isLight
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, contained, light, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Contained
            isLight
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, contained, light, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Contained
            isLight
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, contained, light, icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Contained
            disabled
            isLight
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, contained, light, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Contained
            isLight
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, contained, light, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Contained
            isCircle
            isLight
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, contained, light, circle icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Contained
            disabled
            isCircle
            isLight
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, contained, light, circle icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Contained
            isCircle
            isLight
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
